module.exports = __webpack_public_path__ + "img/step3-4.d125c496.svg";